export const TableColumns = [
    { text: "Mã dịch vụ", icon: <></> },
    { text: "Tên dịch vụ", icon: <></> },
    { text: "Danh mục", icon: <></> },
    { text: "Giá", icon: <></> },
];

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Tên dịch vụ, Mã dịch vụ",
};

export const CreateAddOnTitleBar = {
    title: "Thêm dịch vụ mới",
    cancelButton: "Huỷ bỏ",
    addButton: "Lưu Dịch Vụ",
};
